import { Locales } from "@/app/lang/types";

export const DEFAULT_LANG = Locales.Ru;
